import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-docs-files',
  templateUrl: 'program-docs-files.html',
})
export class ProgramDocsFilesPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  exportjson: any[] = [];
  displayedColumns = ['name', 'filename', 'type', 'ext', 'date', 'actions'];
  dataSource: any;
  documentPanelStatus = false;
  user_fullname: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider,
    public utility: UtilityProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;
      this.user_fullname = user.first_name + ' ' + user.last_name;

      this.database
      .getDocumentsByProgram(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((files) => {
        this.exportjson = files;
        this.dataSource = new MatTableDataSource(files);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program docs and files view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Payers'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'payers.xlsx'); // initiate a file download in browser
  }
  viewDocument(row) {
    console.log('Document: ', row);
    window.open(row.url, '_blank');
  }

  deleteDocument(row) {
  let confirm = this.alertCtrl.create({
    title: "Delete Document",
    message: "Are you sure you want to delete this document?  If so, type 'delete' into the textbox to confirm",
    inputs: [
      {
        name: 'delete_text',
        placeholder: 'delete',
        type: 'text'
      }
    ],
    buttons: [
      {
        text: "Cancel",
        handler: () => {
          // console.log("Don't update");
        }
      },
      {
        text: "Delete Document",
        handler: data => {
          let delete_text = data.delete_text;
          if(delete_text === 'delete') {
        
            this.database.deleteDocument(this.program_id, row.id)
            .then(response => {
              console.log('Delete document id: ', row.id);
              const toast = this.toastCtrl.create({
                message:
                  "The document was successfully deleted.",
                duration: 3000
              });
              toast.present();
            })
            .catch(err => {
              const errortoast = this.toastCtrl.create({
                message:
                  "The document could not be deleted. Error: " + err,
                duration: 3000
              });
              errortoast.present();
            });
          } else {
            return;
          }
        }
      }
    ]
  });
  confirm.present();
  }

  sendFax(doc)  {
    const url = doc.url;
    let confirm = this.alertCtrl.create({
      title: "Send Fax",
      message: "Please enter the fax number",
      inputs: [
        {
          name: 'fax_number',
          placeholder: 'fax number',
          type: 'tel'
        }
      ],
      buttons: [
        {
          text: "Cancel",
          handler: () => {
            // console.log("Don't update");
          }
        },
        {
          text: "Send Fax",
          handler: data => {
            const loading = this.loadingCtrl.create({});
            loading.present().then(() => {

            let fax_number = data.fax_number;
            fax_number = fax_number.replace('-','').replace('(','').replace(')','').replace(/\s+/g,'').replace('+', '');
            if(fax_number.startsWith("1")) {
              fax_number = "+" + fax_number;
            } else {
              fax_number = "+1" + fax_number;
            }
            this.database.sendFax(data.fax_number, url).then(response => {
              loading.dismiss().then(() => {
                console.log('Fax SID: ', response);
                const toast = this.toastCtrl.create({
                  message:
                    "Fax was successfully sent. Your confirmation is: " + response['sid'],
                  duration: 3000
                });
                toast.present();
              });
            })
            .catch(err => {
              loading.dismiss().then(() => {
                const errortoast = this.toastCtrl.create({
                  message:
                    "The fax could not be sent at this time.  Please try again. Error: " + err,
                  duration: 3000
                });
                errortoast.present();
              });
            });

            });
          }
        }
      ]
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/program-docs-files/program-docs-files.ts